export const CHECKOUT_FAILED_EVENT = 'pp-checkout-failed';

export const localesMap = [
  // 阿拉伯语
  { value: 'ar', label: ' بالعربية ' },
  // 保加利亚语
  { value: 'bg', label: 'Български' },
  // 捷克语
  { value: 'cs', label: 'Čeština' },
  // 丹麦语
  { value: 'da', label: 'Dansk' },
  // 德语
  { value: 'de', label: 'Deutsche' },
  // 希腊语
  { value: 'el', label: 'Ελληνικά' },
  // 英语
  { value: 'en', label: 'English' },
  // 西班牙语
  { value: 'es', label: 'Español' },
  // 爱沙尼亚语
  { value: 'et', label: 'Eesti' },
  // 芬兰语
  { value: 'fi', label: 'Suomi' },
  // 法语
  { value: 'fr', label: 'Français' },
  // 克罗地亚语
  { value: 'hr', label: 'Hrvatski' },
  // 匈牙利语
  { value: 'hu', label: 'Magyar' },
  // 印尼语
  { value: 'id', label: 'Bahasa Indonesia' },
  // 意大利语
  { value: 'it', label: 'Italiano' },
  // 日语
  { value: 'ja', label: '日本語で' },
  // 韩国语
  { value: 'ko', label: '한국어' },
  // 立陶宛语
  { value: 'lt', label: 'Lietuvių' },
  // 拉脱维亚语
  { value: 'lv', label: 'Latviešu' },
  // 荷兰语
  { value: 'nl', label: 'Nederlands' },
  // 挪威语
  { value: 'no', label: 'Norsk' },
  // 波兰语
  { value: 'pl', label: 'Polski' },
  // 巴葡语
  { value: 'pt_BR', label: 'Português(Brasil)' },
  // 欧葡语
  { value: 'pt', label: 'Português' },
  // 罗马尼亚语
  { value: 'ro', label: 'Română' },
  // 俄语
  { value: 'ru', label: 'Pусский' },
  // 斯洛伐克语
  { value: 'sk', label: 'Slovenčina' },
  // 斯洛文尼亚语
  { value: 'sl', label: 'Slovenščina' },
  // 塞尔维亚语
  { value: 'sr', label: 'Srpski' },
  // 瑞典语
  { value: 'sv', label: 'Svenska' },
  // 泰国语
  { value: 'th', label: 'ไทย' },
  // 土耳其语
  { value: 'tr', label: 'Türkçe' },
  // 乌克兰语
  { value: 'uk', label: 'Українська' },
  // 乌兹别克语
  { value: 'uz', label: 'O‘zbekcha' },
  // 越南语
  { value: 'vi', label: 'Tiếng Việt' },
  { value: 'zh_CN', label: '中文(简体)' },
  { value: 'zh_HK', label: '中文(香港)' },
  { value: 'zh_TW', label: '中文(繁体)' },
];

export const matchLocalesMap = (languages: string[]) => {
  try {
    const langsSet = new Set(languages);
    return localesMap.filter(item => langsSet.has(item.value));
  } catch (error) {
    return localesMap;
  }
}